import React, {useState, useEffect} from "react";
import { useSearchParams, useLocation, useParams } from "react-router-dom";
import AppBar from "../components/app_bar/AppBar";
import Drawer from "../components/Drawer";
import WotageishiCard from "../components/wotageishi/WotageishiCard";
import WotageishiCardSkeleton from "../components/wotageishi/WotageishiCardSkeleton";
import WotageishiFilter from "../components/wotageishi/WotageishiFilter";
import { 
    Typography, Toolbar, Box, CssBaseline, Grid, Pagination, useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { GetRecordDisplayed } from '../commonFunctions';
import * as CONSTANTS from "../constants"

import { view_wotageishis } from "../services/topic_view";

const WotageishiPage = () => {

    let {lang} = useParams();
    const location = useLocation();

    document.title = `${CONSTANTS.DRAWER.WOTAGEISHI[lang]} - Wotagei Zone`

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));  // Mobile detection

    // hook
    const [maxPage, setMaxPage] = useState(1);
    const [maxRecords, setMaxRecords] = useState(0);
    const [page, setPage] = useState(1);
    const [wotageishis, setWotageishis] = useState(null);
    const [drawerOpen, setDrawerOpen] = useState(false);
            
    const handleDrawerOpen = (open) => {
        if (open === undefined) {
            setDrawerOpen(!drawerOpen)
        } else {
            setDrawerOpen(open);
        }
    }

    // Load Params from URL
    const [searchParams, setSearchParams] = useSearchParams({
        'page': 1,
    });
    
    const handlePageChange = (event, curPage) => {
        searchParams.set('page', curPage)
        let filter = searchParams;
        setPage(curPage);
        setSearchParams(filter);
    };

    // Filter button
    const resetFilter = () => {
        let tempParams = {
            'page': 1,
        }
        setSearchParams(tempParams);
    }

    const submitFilter = (filter) => {
        setSearchParams(filter);
    }

    const fetchWotageishis = async () => {
        try {
            const [status, result] = await view_wotageishis(lang, searchParams);
            if (status === 200) {
                setWotageishis(result.wotageishis);
                setMaxRecords(result.records_count);
                setMaxPage(
                    Math.ceil(result.records_count / 10)
                );
            }
        } catch (error) {
            console.error('Failed to fetch wotageishis.');
        }
    }

    // send api request for url changes
    useEffect(() => {
        fetchWotageishis();
    }, [location.pathname, location.search]);


    return (
        <Box>
            <CssBaseline />
            <AppBar lang={lang} handleDrawerOpen={handleDrawerOpen}/>
            <Box sx={{ display: 'flex' }}>
                <Drawer lang={lang} drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
                <Box component="main" sx={{ flexGrow: 1, p: isMobile? 2: 3 }}>
                    <Toolbar />
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={8}>
                            <Typography 
                                variant="h5"
                                style={{
                                    textAlign: "left",
                                    fontWeight: "bolder",
                                }}
                            >
                                {CONSTANTS.DRAWER.WOTAGEISHI[lang].toUpperCase()}
                            </Typography>
                            <Box 
                                pt={3} pb={3}
                            >
                                <Typography>
                                    {wotageishis? GetRecordDisplayed(lang, maxRecords, page): ''}
                                </Typography>
                            </Box>

                            {/** Load Wotageishi in a Grid as Cards */}
                            <Box pb={3} >
                                <Grid container spacing={3} >
                                    {
                                        wotageishis?
                                        (wotageishis.map((wotageishi) => (
                                            <Grid item xs={12} md={6}>
                                                <WotageishiCard wotageishi={wotageishi} lang={lang}/>
                                            </Grid>
                                        )))
                                        :
                                        <>
                                            <Grid item xs={12} md={6}>
                                                <WotageishiCardSkeleton />
                                            </Grid>
                                            {isMobile? 
                                                <></>
                                                :
                                                <Grid item xs={12} md={6}>
                                                    <WotageishiCardSkeleton />
                                                </Grid>
                                            }
                                        </>
                                    }
                                </Grid>
                            </Box>

                            {/** Pagination */}
                            <Box 
                                display="flex" 
                                justifyContent="center"
                            >
                                <Pagination 
                                    count={maxPage} 
                                    shape="rounded" 
                                    showFirstButton
                                    showLastButton
                                    page={page}
                                    onChange={handlePageChange}
                                />
                            </Box>
                        </Grid>

                        {/** Filters */}
                        <Grid item xs={12} md={4} style={{height: '80vh'}}>
                            <Box >
                                <Typography 
                                    pb={3}
                                    variant="h5" 
                                    style={{
                                        textAlign: "left",
                                        fontWeight: "bolder",
                                    }}
                                >
                                    {CONSTANTS.WAZAREN_FILTER.FILTER[lang].toUpperCase()}
                                </Typography>
                            </Box>
                            <Box pb={3}>
                                <WotageishiFilter resetFilter={resetFilter} submitFilter={submitFilter} lang={lang}/>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Box>
    );
};
 
export default WotageishiPage;